var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHulu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.707 15.957H16.619V8.04297H14.707V15.957ZM11.35 13.701C11.3484 13.8362 11.294 13.9654 11.1983 14.0609C11.1025 14.1564 10.9732 14.2107 10.838 14.212H9.727C9.59178 14.2107 9.46246 14.1564 9.36675 14.0609C9.27104 13.9654 9.21656 13.8362 9.215 13.701V10.511H7.303V13.856C7.303 15.224 8.182 15.946 9.471 15.946H11.339C12.528 15.946 13.251 15.09 13.251 13.856V10.51H11.339C11.349 10.51 11.349 13.6 11.349 13.7L11.35 13.701ZM22.1 10.511V13.701C22.0984 13.8362 22.044 13.9654 21.9483 14.0609C21.8525 14.1564 21.7232 14.2107 21.588 14.212H20.476C20.341 14.2104 20.2119 14.1561 20.1164 14.0606C20.0209 13.9651 19.9666 13.836 19.965 13.701V10.511H18.053V13.856C18.053 15.224 18.931 15.946 20.22 15.946H22.088C23.278 15.946 24 15.09 24 13.856V10.51L22.1 10.511ZM3.78 10.511H2.557C2.123 10.511 1.912 10.621 1.912 10.621V8.04397H0V15.947H1.9V12.768C1.9 12.49 2.134 12.257 2.412 12.257H3.524C3.802 12.257 4.035 12.49 4.035 12.768V15.958H5.947V12.512C5.947 11.067 4.98 10.512 3.78 10.512V10.511Z",
    fill: "#49E290"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHulu);
export default __webpack_public_path__ + "static/media/hulu.555d7db8f8df116e246c0be2c8dde1fc.svg";
export { ForwardRef as ReactComponent };